import { createContext, type Dispatch, type SetStateAction } from 'react';

const BuyDicesContext = createContext(
  {} as {
    activeOfferIndex: number;
    setActiveOfferIndex: Dispatch<SetStateAction<number>>;
  },
);

export { BuyDicesContext };
